import { Picture2 } from 'components/1-atoms/Media/Picture2/Picture2';
import { RichText } from 'components/1-atoms/RichText';
import DownloadIcon from 'icons/download.svg';
import styles from './PublicationContent.module.scss';

export interface PublicationContentProps {
	image?: UI.Image;
	teaser?: string;
	downloadText?: string;
	text: string;
	pdf: UI.File;
}

export const PublicationContent: React.FC<PublicationContentProps> = ({ image, teaser, downloadText, text, pdf }) => {
	return (
		<div className={styles.PublicationContent}>
			{image && <Picture2 {...image} sizes="225px" />}

			<div className={styles.PublicationContent_wrapper}>
				<p className={styles.PublicationContent_teaser}>{teaser}</p>
				{pdf && (
					<>
						<a href={pdf?.url} className={styles.PublicationContent_button} download>
							<DownloadIcon /> <span className={styles.PublicationContent_buttonText}>{downloadText} </span>
						</a>
					</>
				)}
				<RichText content={text} />
			</div>
		</div>
	);
};
